// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Box, Typography, Button, TextField, Select, MenuItem,
//   FormControl, InputLabel, IconButton, Tooltip,
//   CircularProgress, Divider, Chip,
// } from '@mui/material';
// import { Add, Delete, Edit, Visibility, Refresh, Print, Upload } from '@mui/icons-material';
// import { useSelector } from 'react-redux';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';
// import { SnackBarComponent } from '../snackBar/snackBar';
// import { LoadingSpinner } from '../spinner/spinner';
// import TableComponent from '../TableComponent/TableComponent';
// import { API_BASE_URL } from '../../config';

// // ─────────────────────────────────────────────────────────────────────────────
// // CONSTANTS
// // ─────────────────────────────────────────────────────────────────────────────
// const TODAY = new Date().toISOString().split('T')[0];

// const CA_MATRIX_OPTIONS = [
//   'Communication',
//   'Notices & Summons',
//   'Court Proceedings',
//   'Orders & Actions under Section 4',
//   'Sections 5 (2)',
//   'Sections 5 (3)',
//   'Sections 5 (4)',
//   'Sections 6 (1)',
//   'Sections 6 (2)(a)',
//   'Sections 6 (2)(b)',
//   'Sections 6 (2)(c)',
//   'Sections 6 (2)(d)',
//   'Sections 6 (2)(e)',
//   'Sections 6 (2)(f)',
//   'Sections 7 (1)',
//   'Sections 7 (2)',
//   'Sections 8',
//   'Petitions',
//   'Reports',
//   'Meeting proceedings',
// ];

// const STATUS_META = {
//   draft:            { label: 'Draft',             color: 'default' },
//   submitted:        { label: 'Submitted',          color: 'primary' },
//   approved_sploca:  { label: 'Approved (SPLOCA)',  color: 'success' },
//   rejected_sploca:  { label: 'Rejected (SPLOCA)',  color: 'error'   },
//   final:            { label: 'Final',              color: 'success' },
// };

// const StatusChip = ({ status }) => {
//   const m = STATUS_META[status] || { label: status, color: 'default' };
//   return <Chip label={m.label} color={m.color} size="small" />;
// };

// const EDITABLE = ['draft', 'rejected_sploca'];

// // ─────────────────────────────────────────────────────────────────────────────
// // FE DROPDOWN — no "All" option, must select one
// // ─────────────────────────────────────────────────────────────────────────────
// const useFEList = () => {
//   const [feList, setFEList]     = useState([]);
//   const [feLoading, setLoading] = useState(false);
//   useEffect(() => {
//     setLoading(true);
//     axios.get(`${API_BASE_URL}/fe-mgmt/fe-base/`)
//       .then(r => setFEList(Array.isArray(r.data) ? r.data : []))
//       .catch(() => setFEList([]))
//       .finally(() => setLoading(false));
//   }, []);
//   return { feList, feLoading };
// };

// const FESelect = ({ value, onChange, disabled }) => {
//   const { feList, feLoading } = useFEList();
//   return (
//     <FormControl size="small" fullWidth disabled={disabled || feLoading}>
//       <InputLabel>Name of the FE {feLoading ? '(Loading...)' : ''}</InputLabel>
//       <Select value={value || ''} label={`Name of the FE ${feLoading ? '(Loading...)' : ''}`}
//         onChange={e => onChange && onChange(e.target.value)}>
//         <MenuItem value=""><em>-- Select --</em></MenuItem>
//         {feList.map(fe => <MenuItem key={fe.id} value={fe.id}>{fe.name_of_fe}</MenuItem>)}
//       </Select>
//     </FormControl>
//   );
// };

// // FE filter for list — no "All" option, must pick one to see records
// const FEFilterSelect = ({ value, onChange }) => {
//   const { feList, feLoading } = useFEList();
//   return (
//     <FormControl size="small" sx={{ minWidth: 260 }} disabled={feLoading}>
//       <InputLabel>List of FE {feLoading ? '(Loading...)' : ''}</InputLabel>
//       <Select value={value || ''} label={`List of FE ${feLoading ? '(Loading...)' : ''}`}
//         onChange={e => onChange(e.target.value)}>
//         <MenuItem value=""><em>-- Select --</em></MenuItem>
//         {feList.map(fe => <MenuItem key={fe.id} value={fe.id}>{fe.name_of_fe}</MenuItem>)}
//       </Select>
//     </FormControl>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // BLANK ITEM
// // ─────────────────────────────────────────────────────────────────────────────
// const blankItem = () => ({
//   activity: '',
//   details: '',
//   file: null,
//   date: TODAY,
//   _fileObj: null,
// });

// // ─────────────────────────────────────────────────────────────────────────────
// // SINGLE ROW EDITOR
// // ─────────────────────────────────────────────────────────────────────────────
// const MatrixRow = ({ item, idx, ro, onUpdate, onDelete, onFileChange }) => (
//   <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 2, mb: 1,
//     background: idx % 2 === 0 ? '#fafafa' : '#fff' }}>
//     <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 1 }}>
//       {/* Activity dropdown */}
//       {ro ? (
//         <Typography variant="body2" sx={{ pt: 0.5 }}>{item.activity}</Typography>
//       ) : (
//         <FormControl size="small" fullWidth>
//           <Select value={item.activity || ''} displayEmpty
//             onChange={e => onUpdate(idx, 'activity', e.target.value)}>
//             <MenuItem value=""><em>-- Select --</em></MenuItem>
//             {CA_MATRIX_OPTIONS.map(opt => (
//               <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       )}

//       {/* File */}
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//         {ro ? (
//           item.file ? (
//             <Button size="small" variant="outlined" href={item.file} target="_blank">
//               View File
//             </Button>
//           ) : (
//             <Typography variant="caption" color="text.disabled">No file</Typography>
//           )
//         ) : (
//           <>
//             <Button size="small" variant="outlined" component="label" startIcon={<Upload />}>
//               Choose File
//               <input type="file" hidden onChange={e => onFileChange(idx, e.target.files[0])} />
//             </Button>
//             <Typography variant="caption" color={item._fileObj ? 'success.main' : 'text.disabled'}>
//               {item._fileObj ? item._fileObj.name : (item.file ? 'File uploaded' : 'No file chosen')}
//             </Typography>
//           </>
//         )}
//       </Box>
//     </Box>

//     <Box sx={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 2, alignItems: 'flex-start' }}>
//       <TextField label="Details" value={item.details || ''} size="small" fullWidth
//         multiline rows={2} disabled={ro}
//         onChange={ro ? undefined : e => onUpdate(idx, 'details', e.target.value)} />

//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 180 }}>
//         <TextField type="date" size="small" value={item.date || TODAY}
//           InputLabelProps={{ shrink: true }} disabled={ro}
//           onChange={ro ? undefined : e => onUpdate(idx, 'date', e.target.value)} />
//         {!ro && (
//           <IconButton size="small" color="error" onClick={() => onDelete(idx)}>
//             <Delete fontSize="small" />
//           </IconButton>
//         )}
//       </Box>
//     </Box>
//   </Box>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // APPROVAL PANEL
// // ─────────────────────────────────────────────────────────────────────────────
// const APPROVAL_ACTIONS = {
//   competent_authority: [
//     { a: 'submit',         l: 'Submit',          c: 'primary', s: EDITABLE },
//   ],
//   sploca:              [
//     { a: 'approve_sploca', l: 'Approve',          c: 'success', s: ['submitted'] },
//     { a: 'reject_sploca',  l: 'Reject',           c: 'error',   s: ['submitted'] },
//     { a: 'finalise',       l: 'Finalise',         c: 'primary', s: ['approved_sploca'] },
//   ],
//   admin:               [
//     { a: 'finalise',       l: 'Finalise',         c: 'primary', s: ['approved_sploca'] },
//   ],
// };

// const ApprovalPanel = ({ form, apiPath, role, onRefresh }) => {
//   const [remarks, setRemarks] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [snack, setSnack]     = useState({ open: false, message: '', severity: 'info' });

//   const available = (APPROVAL_ACTIONS[role] || []).filter(a => a.s.includes(form.status));
//   if (!available.length) return null;

//   const doAction = async (action) => {
//     setLoading(true);
//     try {
//       await api.post(`${apiPath}${form.id}/action/`, { action, remarks });
//       setSnack({ open: true, message: 'Action completed', severity: 'success' });
//       onRefresh();
//     } catch (e) {
//       setSnack({ open: true, message: e.response?.data?.error || 'Failed', severity: 'error' });
//     } finally { setLoading(false); }
//   };

//   return (
//     <Box sx={{ mt: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 2, background: '#f5f5f5' }}>
//       <Typography variant="subtitle2" fontWeight="bold" mb={1}>Available Actions</Typography>
//       <TextField fullWidth size="small" label="Remarks (optional)" value={remarks}
//         onChange={e => setRemarks(e.target.value)} multiline rows={2} sx={{ mb: 2 }} />
//       <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//         {available.map(a => (
//           <Button key={a.a} variant="contained" color={a.c} size="small"
//             disabled={loading} onClick={() => doAction(a.a)}
//             startIcon={loading ? <CircularProgress size={14} /> : null}>
//             {a.l}
//           </Button>
//         ))}
//       </Box>
//       <SnackBarComponent open={snack.open} message={snack.message}
//         severity={snack.severity} onClose={() => setSnack(s => ({ ...s, open: false }))} />
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // MAIN COMPONENT
// // ─────────────────────────────────────────────────────────────────────────────
// const EP = '/ca-matrix/';

// export const CAActivityMatrixComponent = () => {
//   const role = useSelector(s => s.auth.role);
//   const [view, setView]         = useState('list');
//   const [feFilter, setFeFilter] = useState('');
//   const [list, setList]         = useState([]);
//   const [listLoading, setLL]    = useState(false);
//   const [formData, setFormData] = useState({ fe: '', date: TODAY });
//   const [items, setItems]       = useState([blankItem()]);
//   const [selected, setSelected] = useState(null);
//   const [saving, setSaving]     = useState(false);
//   const [snack, setSnack]       = useState({ open: false, message: '', severity: 'info' });

//   const canCreate = ['competent_authority', 'admin'].includes(role);

//   const fetchList = useCallback(async () => {
//     if (!feFilter) { setList([]); return; }
//     setLL(true);
//     try {
//       const res = await api.get(EP, { params: { fe: feFilter } });
//       setList(res.data);
//     } catch { setSnack({ open: true, message: 'Failed to load', severity: 'error' }); }
//     finally { setLL(false); }
//   }, [feFilter]);

//   useEffect(() => { fetchList(); }, [fetchList]);

//   const set = (f, v) => setFormData(d => ({ ...d, [f]: v }));
//   const updateItem    = (idx, field, value) => setItems(prev => prev.map((it, i) => i === idx ? { ...it, [field]: value } : it));
//   const deleteItem    = (idx) => setItems(prev => prev.filter((_, i) => i !== idx));
//   const handleFileChange = (idx, file) => setItems(prev => prev.map((it, i) => i === idx ? { ...it, _fileObj: file } : it));

//   const openNew = () => {
//     setFormData({ fe: '', date: TODAY });
//     setItems([blankItem()]);
//     setSelected(null);
//     setView('form');
//   };

//   const openEdit = async (row) => {
//     try {
//       const res = await api.get(`${EP}${row.id}/`);
//       setFormData({ fe: res.data.fe, date: res.data.date });
//       setItems(res.data.items?.length ? res.data.items.map(it => ({ ...it, _fileObj: null })) : [blankItem()]);
//       setSelected(res.data);
//     } catch {
//       setFormData({ fe: row.fe, date: row.date });
//       setItems([blankItem()]);
//       setSelected(row);
//     }
//     setView('form');
//   };

//   const openView = async (row) => {
//     try {
//       const res = await api.get(`${EP}${row.id}/`);
//       setFormData({ fe: res.data.fe, date: res.data.date, fe_detail: res.data.fe_detail });
//       setItems(res.data.items || []);
//       setSelected(res.data);
//     } catch {
//       setFormData(row);
//       setItems(row.items || []);
//       setSelected(row);
//     }
//     setView('detail');
//   };

//   const handleSave = async () => {
//     if (!formData.fe) {
//       setSnack({ open: true, message: 'Please select a Financial Establishment', severity: 'warning' });
//       return;
//     }
//     setSaving(true);
//     try {
//       const itemsPayload = items
//         .filter(it => it.activity)
//         .map(({ _fileObj, file, ...rest }) => ({ ...rest, file: null }));

//       let res;
//       if (selected) {
//         res = await api.patch(`${EP}${selected.id}/`, { ...formData, items: itemsPayload });
//       } else {
//         res = await api.post(EP, { ...formData, items: itemsPayload });
//       }

//       const savedItems = res.data?.items || [];
//       for (let i = 0; i < items.length; i++) {
//         if (items[i]._fileObj && savedItems[i]?.id) {
//           const fd = new FormData();
//           fd.append('file', items[i]._fileObj);
//           await api.patch(`/ca-matrix/item/${savedItems[i].id}/file/`, fd, {
//             headers: { 'Content-Type': 'multipart/form-data' },
//           });
//         }
//       }

//       setSnack({ open: true, message: selected ? 'Updated successfully' : 'Saved successfully', severity: 'success' });
//       fetchList();
//       setView('list');
//     } catch (e) {
//       setSnack({ open: true, message: JSON.stringify(e.response?.data) || 'Save failed', severity: 'error' });
//     } finally { setSaving(false); }
//   };

//   // ── Table columns ──────────────────────────────────────────────────────────
//   const tableCols = [
//     { id: 'slNo',    field: 'slNo',    headerName: 'Sl No.',  width: 70  },
//     { id: 'date',    field: 'date',    headerName: 'Date',    width: 130 },
//     { id: 'fe_name', field: 'fe_name', headerName: 'FE Name', width: 260 },
//     { id: 'statusLabel', field: 'statusLabel', headerName: 'Status', width: 200 },
//     {
//       id: 'actions', field: 'actions', headerName: 'Actions', width: 130,
//       renderCell: p => (
//         <Box sx={{ display: 'flex', gap: 0.5 }}>
//           <Tooltip title="View">
//             <IconButton size="small" onClick={() => openView(p.row)}><Visibility fontSize="small" /></IconButton>
//           </Tooltip>
//           {EDITABLE.includes(p.row.status) && canCreate && (
//             <Tooltip title="Edit">
//               <IconButton size="small" color="primary" onClick={() => openEdit(p.row)}><Edit fontSize="small" /></IconButton>
//             </Tooltip>
//           )}
//         </Box>
//       ),
//     },
//   ];

//   const tableRows = list.map((item, i) => ({
//     ...item,
//     slNo: i + 1,
//     statusLabel: STATUS_META[item.status]?.label || item.status,
//     fe_name: item.fe_detail?.name_of_fe || '',
//   }));

//   return (
//     <Box sx={{ width: '100%', mt: 2, borderRadius: 2,
//       boxShadow: '0 4px 12px rgba(0,0,0,0.08)', backgroundColor: '#fff' }}>

//       <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0', background: 'rgba(25,118,210,0.04)' }}>
//         <Typography variant="h5" fontWeight="bold">CA Activity Matrix</Typography>
//         <Typography variant="caption" color="text.secondary">
//           Flow: Competent Authority → SPLOCA
//         </Typography>
//       </Box>

//       <Box sx={{ p: 3 }}>

//         {/* ── LIST ──────────────────────────────────────────────────────────── */}
//         {view === 'list' && (
//           <>
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//               <FEFilterSelect value={feFilter} onChange={v => setFeFilter(v)} />
//               <Box sx={{ display: 'flex', gap: 1 }}>
//                 <Tooltip title="Refresh"><IconButton onClick={fetchList}><Refresh /></IconButton></Tooltip>
//                 {canCreate && (
//                   <Button variant="contained" startIcon={<Add />} onClick={openNew}>Add New</Button>
//                 )}
//               </Box>
//             </Box>

//             {!feFilter ? (
//               <Box sx={{ p: 4, textAlign: 'center', border: '1px dashed #ccc', borderRadius: 2 }}>
//                 <Typography color="text.secondary">
//                   Please select a Financial Establishment above to view records
//                 </Typography>
//               </Box>
//             ) : listLoading ? (
//               <Box display="flex" justifyContent="center" p={4}><LoadingSpinner size={30} /></Box>
//             ) : (
//               <TableComponent
//                 columns={tableCols}
//                 rows={tableRows}
//                 manageColumnStatus
//                 enableSort={true}
//                 sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//               />
//             )}
//           </>
//         )}

//         {/* ── FORM ──────────────────────────────────────────────────────────── */}
//         {view === 'form' && (
//           <>
//             <Button size="small" onClick={() => setView('list')} sx={{ mb: 2 }}>← Back to List</Button>
//             <Typography variant="h6" fontWeight="bold" textAlign="center" mb={2}>
//               {selected ? 'Edit CA Activity Matrix' : 'Add New CA Activity Matrix'}
//             </Typography>
//             <Divider sx={{ mb: 2 }} />

//             {/* Header */}
//             <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 3 }}>
//               <Box>
//                 <Typography variant="caption" color="text.secondary">Date</Typography>
//                 <TextField type="date" size="small" fullWidth value={formData.date || TODAY}
//                   InputLabelProps={{ shrink: true }}
//                   onChange={e => set('date', e.target.value)} />
//               </Box>
//               <Box>
//                 <Typography variant="caption" color="text.secondary">Name of the FE</Typography>
//                 <FESelect value={formData.fe} onChange={v => set('fe', v)} disabled={false} />
//               </Box>
//             </Box>

//             {/* Items */}
//             <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden', mb: 2 }}>
//               <Box sx={{ background: '#1976d2', color: '#fff', px: 2, py: 1 }}>
//                 <Typography variant="body2" fontWeight="bold">Sl.No</Typography>
//               </Box>
//               {items.map((item, idx) => (
//                 <Box key={idx} sx={{ display: 'flex', gap: 1, p: 1,
//                   borderBottom: idx < items.length - 1 ? '1px solid #eee' : 'none' }}>
//                   <Box sx={{ pt: 1.5, minWidth: 28 }}>
//                     <Typography variant="body2" color="text.secondary">{idx + 1}</Typography>
//                   </Box>
//                   <Box sx={{ flex: 1 }}>
//                     <MatrixRow item={item} idx={idx} ro={false}
//                       onUpdate={updateItem} onDelete={deleteItem} onFileChange={handleFileChange} />
//                   </Box>
//                 </Box>
//               ))}
//             </Box>

//             {/* + button */}
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
//               <Button variant="contained" size="small" sx={{ minWidth: 36, px: 1 }}
//                 onClick={() => setItems(prev => [...prev, blankItem()])}>
//                 <Add fontSize="small" />
//               </Button>
//             </Box>

//             <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
//               <Button variant="outlined" onClick={() => setView('list')}>Cancel</Button>
//               <Button variant="contained" onClick={handleSave} disabled={saving}
//                 startIcon={saving ? <CircularProgress size={16} /> : null}>
//                 {saving ? 'Saving...' : 'Save'}
//               </Button>
//               <Button variant="outlined" onClick={() => {
//                 setFormData({ fe: '', date: TODAY });
//                 setItems([blankItem()]);
//               }}>Reset</Button>
//             </Box>
//           </>
//         )}

//         {/* ── DETAIL ────────────────────────────────────────────────────────── */}
//         {view === 'detail' && selected && (
//           <>
//             <Button size="small" onClick={() => setView('list')} sx={{ mb: 2 }}>← Back to List</Button>

//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//               <Box>
//                 <Typography variant="h6" fontWeight="bold">CA Activity Matrix</Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   FE: <strong>{selected.fe_detail?.name_of_fe || ''}</strong>
//                   &nbsp;|&nbsp; Date: <strong>{selected.date}</strong>
//                 </Typography>
//               </Box>
//               <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                 <StatusChip status={selected.status} />
//                 <Button variant="outlined" size="small" startIcon={<Print />} onClick={() => window.print()}>
//                   Print
//                 </Button>
//               </Box>
//             </Box>
//             <Divider sx={{ mb: 2 }} />

//             <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden', mb: 2 }}>
//               <Box sx={{ background: '#1976d2', color: '#fff', px: 2, py: 1 }}>
//                 <Typography variant="body2" fontWeight="bold">Sl.No</Typography>
//               </Box>
//               {items.map((item, idx) => (
//                 <Box key={idx} sx={{ display: 'flex', gap: 1, p: 1,
//                   borderBottom: idx < items.length - 1 ? '1px solid #eee' : 'none' }}>
//                   <Box sx={{ pt: 1.5, minWidth: 28 }}>
//                     <Typography variant="body2" color="text.secondary">{idx + 1}</Typography>
//                   </Box>
//                   <Box sx={{ flex: 1 }}>
//                     <MatrixRow item={item} idx={idx} ro={true}
//                       onUpdate={() => {}} onDelete={() => {}} onFileChange={() => {}} />
//                   </Box>
//                 </Box>
//               ))}
//             </Box>

//             <ApprovalPanel form={selected} apiPath={EP} role={role}
//               onRefresh={() => openView(selected)} />

//             <Box sx={{ mt: 2 }}>
//               <Button variant="outlined" onClick={() => setView('list')}>Back to List</Button>
//             </Box>
//           </>
//         )}
//       </Box>

//       <SnackBarComponent open={snack.open} message={snack.message}
//         severity={snack.severity} onClose={() => setSnack(s => ({ ...s, open: false }))} />
//     </Box>
//   );
// };


import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Typography, Button, TextField, Select, MenuItem,
  FormControl, IconButton, Tooltip,
  CircularProgress, Divider, Chip,
} from '@mui/material';
import { Add, Delete, Edit, Visibility, Refresh, Print, Upload } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import api from '../../../../api/axiosInterceptor';
import { SnackBarComponent } from '../../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../../Components/spinner/spinner';
import TableComponent from '../../../../Components/TableComponent/TableComponent';
import FEDropdown from '../feDropdown';

// ─────────────────────────────────────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────────────────────────────────────
const TODAY = new Date().toISOString().split('T')[0];

const CA_MATRIX_OPTIONS = [
  'Communication',
  'Notices & Summons',
  'Court Proceedings',
  'Orders & Actions under Section 4',
  'Sections 5 (2)',
  'Sections 5 (3)',
  'Sections 5 (4)',
  'Sections 6 (1)',
  'Sections 6 (2)(a)',
  'Sections 6 (2)(b)',
  'Sections 6 (2)(c)',
  'Sections 6 (2)(d)',
  'Sections 6 (2)(e)',
  'Sections 6 (2)(f)',
  'Sections 7 (1)',
  'Sections 7 (2)',
  'Sections 8',
  'Petitions',
  'Reports',
  'Meeting proceedings',
];

const STATUS_META = {
  draft:            { label: 'Draft',             color: 'default' },
  submitted:        { label: 'Submitted',          color: 'primary' },
  approved_sploca:  { label: 'Approved (SPLOCA)',  color: 'success' },
  rejected_sploca:  { label: 'Rejected (SPLOCA)',  color: 'error'   },
  final:            { label: 'Final',              color: 'success' },
};

const StatusChip = ({ status }) => {
  const m = STATUS_META[status] || { label: status, color: 'default' };
  return <Chip label={m.label} color={m.color} size="small" />;
};

const EDITABLE = ['draft', 'rejected_sploca'];

// ─────────────────────────────────────────────────────────────────────────────
// BLANK ITEM
// ─────────────────────────────────────────────────────────────────────────────
const blankItem = () => ({
  activity: '',
  details: '',
  file: null,
  date: TODAY,
  _fileObj: null,
});

// ─────────────────────────────────────────────────────────────────────────────
// SINGLE ROW EDITOR
// ─────────────────────────────────────────────────────────────────────────────
const MatrixRow = ({ item, idx, ro, onUpdate, onDelete, onFileChange }) => (
  <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 2, mb: 1,
    background: idx % 2 === 0 ? '#fafafa' : '#fff' }}>
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 1 }}>
      {/* Activity dropdown */}
      {ro ? (
        <Typography variant="body2" sx={{ pt: 0.5 }}>{item.activity}</Typography>
      ) : (
        <FormControl size="small" fullWidth>
          <Select value={item.activity || ''} displayEmpty
            onChange={e => onUpdate(idx, 'activity', e.target.value)}>
            <MenuItem value=""><em>-- Select --</em></MenuItem>
            {CA_MATRIX_OPTIONS.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* File */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {ro ? (
          item.file ? (
            <Button size="small" variant="outlined" href={item.file} target="_blank">
              View File
            </Button>
          ) : (
            <Typography variant="caption" color="text.disabled">No file</Typography>
          )
        ) : (
          <>
            <Button size="small" variant="outlined" component="label" startIcon={<Upload />}>
              Choose File
              <input type="file" hidden onChange={e => onFileChange(idx, e.target.files[0])} />
            </Button>
            <Typography variant="caption" color={item._fileObj ? 'success.main' : 'text.disabled'}>
              {item._fileObj ? item._fileObj.name : (item.file ? 'File uploaded' : 'No file chosen')}
            </Typography>
          </>
        )}
      </Box>
    </Box>

    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 2, alignItems: 'flex-start' }}>
      <TextField label="Details" value={item.details || ''} size="small" fullWidth
        multiline rows={2} disabled={ro}
        onChange={ro ? undefined : e => onUpdate(idx, 'details', e.target.value)} />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 180 }}>
        <TextField type="date" size="small" value={item.date || TODAY}
          InputLabelProps={{ shrink: true }} disabled={ro}
          onChange={ro ? undefined : e => onUpdate(idx, 'date', e.target.value)} />
        {!ro && (
          <IconButton size="small" color="error" onClick={() => onDelete(idx)}>
            <Delete fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Box>
  </Box>
);

// ─────────────────────────────────────────────────────────────────────────────
// APPROVAL PANEL
// ─────────────────────────────────────────────────────────────────────────────
const APPROVAL_ACTIONS = {
  competent_authority: [
    { a: 'submit', l: 'Submit', c: 'primary', s: EDITABLE },
  ],
  sploca: [
    { a: 'approve_sploca', l: 'Approve',  c: 'success', s: ['submitted'] },
    { a: 'reject_sploca',  l: 'Reject',   c: 'error',   s: ['submitted'] },
    { a: 'finalise',       l: 'Finalise', c: 'primary', s: ['approved_sploca'] },
  ],
  admin: [
    { a: 'finalise', l: 'Finalise', c: 'primary', s: ['approved_sploca'] },
  ],
};

const ApprovalPanel = ({ form, apiPath, role, onRefresh }) => {
  const [remarks, setRemarks] = useState('');
  const [loading, setLoading] = useState(false);
  const [snack, setSnack]     = useState({ open: false, message: '', severity: 'info' });

  const available = (APPROVAL_ACTIONS[role] || []).filter(a => a.s.includes(form.status));
  if (!available.length) return null;

  const doAction = async (action) => {
    setLoading(true);
    try {
      await api.post(`${apiPath}${form.id}/action/`, { action, remarks });
      setSnack({ open: true, message: 'Action completed', severity: 'success' });
      onRefresh();
    } catch (e) {
      setSnack({ open: true, message: e.response?.data?.error || 'Failed', severity: 'error' });
    } finally { setLoading(false); }
  };

  return (
    <Box sx={{ mt: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 2, background: '#f5f5f5' }}>
      <Typography variant="subtitle2" fontWeight="bold" mb={1}>Available Actions</Typography>
      <TextField fullWidth size="small" label="Remarks (optional)" value={remarks}
        onChange={e => setRemarks(e.target.value)} multiline rows={2} sx={{ mb: 2 }} />
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {available.map(a => (
          <Button key={a.a} variant="contained" color={a.c} size="small"
            disabled={loading} onClick={() => doAction(a.a)}
            startIcon={loading ? <CircularProgress size={14} /> : null}>
            {a.l}
          </Button>
        ))}
      </Box>
      <SnackBarComponent open={snack.open} message={snack.message}
        severity={snack.severity} onClose={() => setSnack(s => ({ ...s, open: false }))} />
    </Box>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const EP = 'legal/ca-matrix/';

export const CAActivityMatrixComponent = () => {
  const role = useSelector(s => s.auth.role);

  const [view, setView]         = useState('list');
  // filterFE holds the full FE object (id + name_of_fe) — mirrors petition pattern
  const [filterFE, setFilterFE] = useState(null);
  const [list, setList]         = useState([]);
  const [listLoading, setLL]    = useState(false);
  // formData.fe holds the FE id; _fe_display holds the name for display
  const [formData, setFormData] = useState({ fe: '', _fe_display: '', date: TODAY });
  const [items, setItems]       = useState([blankItem()]);
  const [selected, setSelected] = useState(null);
  const [saving, setSaving]     = useState(false);
  const [snack, setSnack]       = useState({ open: false, message: '', severity: 'info' });

  const canCreate = ['competent_authority', 'admin'].includes(role);

  // ── Fetch list — requires filterFE ───────────────────────────────────────
  const fetchList = useCallback(async () => {
    if (!filterFE) { setList([]); return; }
    setLL(true);
    try {
      const res = await api.get(EP, { params: { fe: filterFE.id } });
      setList(res.data);
    } catch {
      setSnack({ open: true, message: 'Failed to load', severity: 'error' });
    } finally { setLL(false); }
  }, [filterFE]);

  useEffect(() => { fetchList(); }, [fetchList]);

  // ── Field helpers ─────────────────────────────────────────────────────────
  const set = (f, v) => setFormData(d => ({ ...d, [f]: v }));

  // FE selected in the form → store id + display name (mirrors petition)
  const handleFESelect = (fe) => {
    if (!fe) {
      setFormData(d => ({ ...d, fe: '', _fe_display: '', fe_detail: null }));
      return;
    }
    setFormData(d => ({ ...d, fe: fe.id, _fe_display: fe.name_of_fe, fe_detail: fe }));
  };

  const updateItem     = (idx, field, value) =>
    setItems(prev => prev.map((it, i) => i === idx ? { ...it, [field]: value } : it));
  const deleteItem     = (idx) => setItems(prev => prev.filter((_, i) => i !== idx));
  const handleFileChange = (idx, file) =>
    setItems(prev => prev.map((it, i) => i === idx ? { ...it, _fileObj: file } : it));

  // ── Open views ────────────────────────────────────────────────────────────
  const openNew = () => {
    setFormData({ fe: '', _fe_display: '', date: TODAY });
    setItems([blankItem()]);
    setSelected(null);
    setView('form');
  };

  const openEdit = async (row) => {
    try {
      const res = await api.get(`${EP}${row.id}/`);
      setFormData({
        fe: res.data.fe,
        _fe_display: res.data.fe_detail?.name_of_fe || '',
        fe_detail: res.data.fe_detail,
        date: res.data.date,
      });
      setItems(res.data.items?.length
        ? res.data.items.map(it => ({ ...it, _fileObj: null }))
        : [blankItem()]);
      setSelected(res.data);
    } catch {
      setFormData({ fe: row.fe, _fe_display: row.fe_detail?.name_of_fe || '', date: row.date });
      setItems([blankItem()]);
      setSelected(row);
    }
    setView('form');
  };

  const openView = async (row) => {
    try {
      const res = await api.get(`${EP}${row.id}/`);
      setFormData({
        fe: res.data.fe,
        _fe_display: res.data.fe_detail?.name_of_fe || '',
        fe_detail: res.data.fe_detail,
        date: res.data.date,
      });
      setItems(res.data.items || []);
      setSelected(res.data);
    } catch {
      setFormData({ ...row, _fe_display: row.fe_detail?.name_of_fe || '' });
      setItems(row.items || []);
      setSelected(row);
    }
    setView('detail');
  };

  // ── Save ──────────────────────────────────────────────────────────────────
  const handleSave = async () => {
    if (!formData.fe) {
      setSnack({ open: true, message: 'Please select a Financial Establishment', severity: 'warning' });
      return;
    }
    setSaving(true);
    // Strip display-only fields before sending to API (mirrors petition)
    const { _fe_display, fe_detail, ...payload } = formData;
    try {
      const itemsPayload = items
        .filter(it => it.activity)
        .map(({ _fileObj, file, ...rest }) => ({ ...rest, file: null }));

      let res;
      if (selected) {
        res = await api.patch(`${EP}${selected.id}/`, { ...payload, items: itemsPayload });
      } else {
        res = await api.post(EP, { ...payload, items: itemsPayload });
      }

      const savedItems = res.data?.items || [];
      for (let i = 0; i < items.length; i++) {
        if (items[i]._fileObj && savedItems[i]?.id) {
          const fd = new FormData();
          fd.append('file', items[i]._fileObj);
          await api.patch(`legal/ca-matrix/item/${savedItems[i].id}/file/`, fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        }
      }

      setSnack({ open: true, message: selected ? 'Updated successfully' : 'Saved successfully', severity: 'success' });
      fetchList();
      setView('list');
    } catch (e) {
      setSnack({ open: true, message: JSON.stringify(e.response?.data) || 'Save failed', severity: 'error' });
    } finally { setSaving(false); }
  };

  // ── Table columns ─────────────────────────────────────────────────────────
  const tableCols = [
    { id: 'slNo',        field: 'slNo',        headerName: 'Sl No.',  width: 70  },
    { id: 'date',        field: 'date',        headerName: 'Date',    width: 130 },
    { id: 'fe_name',     field: 'fe_name',     headerName: 'FE Name', width: 260 },
    // { id: 'activity',     field: 'activity',     headerName: 'Activity', width: 260 },
    { id: 'statusLabel', field: 'statusLabel', headerName: 'Status',  width: 200 },
    {
      id: 'actions', field: 'actions', headerName: 'Actions', width: 130,
      renderCell: p => (
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Tooltip title="View">
            <IconButton size="small" onClick={() => openView(p.row)}><Visibility fontSize="small" /></IconButton>
          </Tooltip>
          {EDITABLE.includes(p.row.status) && canCreate && (
            <Tooltip title="Edit">
              <IconButton size="small" color="primary" onClick={() => openEdit(p.row)}><Edit fontSize="small" /></IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];

  // Filter table rows to the selected FE (client-side, same as petition)
//   const allRows = list.map((item, i) => ({
//     ...item,
//     slNo: i + 1,
//     statusLabel: STATUS_META[item.status]?.label || item.status,
//     fe_name: item.fe_detail?.name_of_fe || '',
//     activity: item.items?.[0]?.activity || '', 
//   }));

const allRows = list.map((item, i) => ({
  ...item,
  slNo: i + 1,
  statusLabel: STATUS_META[item.status]?.label || item.status,
  fe_name: item.fe_detail?.name_of_fe || '',

  activity: item.items?.length
    ? item.items.map((it, idx) => `${idx + 1}. ${it.activity}`).join(', ')
    : '',
}));

  const tableRows = filterFE
    ? allRows.filter(r => r.fe === filterFE.id || r.fe_detail?.id === filterFE.id)
    : [];

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ width: '100%', mt: 2, borderRadius: 2,
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)', backgroundColor: '#fff' }}>

      <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0', background: 'rgba(25,118,210,0.04)' }}>
        <Typography variant="h5" fontWeight="bold">CA Activity Matrix</Typography>
        <Typography variant="caption" color="text.secondary">
          Flow: Competent Authority → SPLOCA
        </Typography>
      </Box>

      <Box sx={{ p: 3 }}>

        {/* ── LIST ──────────────────────────────────────────────────────── */}
        {view === 'list' && (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              {/* FE filter using shared FEDropdown */}
              <Box sx={{ minWidth: 300 }}>
                <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                  Select Financial Establishment to view records
                </Typography>
                <FEDropdown
                  value={filterFE?.id || null}
                  disabled={false}
                  showAddress={true}
                  onSelect={fe => setFilterFE(fe || null)}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Tooltip title="Refresh">
                  <IconButton onClick={fetchList}><Refresh /></IconButton>
                </Tooltip>
                {canCreate && (
                  <Button variant="contained" startIcon={<Add />} onClick={openNew}>
                    Add New
                  </Button>
                )}
              </Box>
            </Box>

            {!filterFE ? (
              <Box sx={{ p: 4, textAlign: 'center', border: '1px dashed #ccc', borderRadius: 2 }}>
                <Typography color="text.secondary">
                  Please select a Financial Establishment above to view records
                </Typography>
              </Box>
            ) : listLoading ? (
              <Box display="flex" justifyContent="center" p={4}><LoadingSpinner size={30} /></Box>
            ) : (
              <TableComponent
                columns={tableCols}
                rows={tableRows}
                manageColumnStatus
                enableSort={true}
                sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
              />
            )}
          </>
        )}

        {/* ── FORM ──────────────────────────────────────────────────────── */}
        {view === 'form' && (
          <>
            <Button size="small" onClick={() => setView('list')} sx={{ mb: 2 }}>← Back to List</Button>
            <Typography variant="h6" fontWeight="bold" textAlign="center" mb={2}>
              {selected ? 'Edit CA Activity Matrix' : 'Add New CA Activity Matrix'}
            </Typography>
            <Divider sx={{ mb: 2 }} />

            {/* Header */}
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 3 }}>
              <Box>
                <Typography variant="caption" color="text.secondary">Date</Typography>
                <TextField type="date" size="small" fullWidth value={formData.date || TODAY}
                  InputLabelProps={{ shrink: true }}
                  onChange={e => set('date', e.target.value)} />
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary">Name of the FE</Typography>
                {/* Shared FEDropdown — same props as petition */}
                <FEDropdown
                  value={formData.fe || null}
                  disabled={false}
                  showAddress={true}
                  onSelect={handleFESelect}
                />
                {formData._fe_display && (
                  <Typography variant="caption" sx={{ color: 'success.dark', mt: 0.4, display: 'block' }}>
                    ✓ <strong>{formData._fe_display}</strong>
                  </Typography>
                )}
              </Box>
            </Box>

            {/* Items */}
            <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden', mb: 2 }}>
              <Box sx={{ background: '#1976d2', color: '#fff', px: 2, py: 1 }}>
                <Typography variant="body2" fontWeight="bold">Sl.No</Typography>
              </Box>
              {items.map((item, idx) => (
                <Box key={idx} sx={{ display: 'flex', gap: 1, p: 1,
                  borderBottom: idx < items.length - 1 ? '1px solid #eee' : 'none' }}>
                  <Box sx={{ pt: 1.5, minWidth: 28 }}>
                    <Typography variant="body2" color="text.secondary">{idx + 1}</Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <MatrixRow item={item} idx={idx} ro={false}
                      onUpdate={updateItem} onDelete={deleteItem} onFileChange={handleFileChange} />
                  </Box>
                </Box>
              ))}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
              <Button variant="contained" size="small" sx={{ minWidth: 36, px: 1 }}
                onClick={() => setItems(prev => [...prev, blankItem()])}>
                <Add fontSize="small" />
              </Button>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <Button variant="outlined" onClick={() => setView('list')}>Cancel</Button>
              <Button variant="contained" onClick={handleSave} disabled={saving}
                startIcon={saving ? <CircularProgress size={16} /> : null}>
                {saving ? 'Saving...' : 'Save'}
              </Button>
              <Button variant="outlined" onClick={() => {
                setFormData({ fe: '', _fe_display: '', date: TODAY });
                setItems([blankItem()]);
              }}>Reset</Button>
            </Box>
          </>
        )}

        {/* ── DETAIL ────────────────────────────────────────────────────── */}
        {view === 'detail' && selected && (
          <>
            <Button size="small" onClick={() => setView('list')} sx={{ mb: 2 }}>← Back to List</Button>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Box>
                <Typography variant="h6" fontWeight="bold">CA Activity Matrix</Typography>
                <Typography variant="body2" color="text.secondary">
                  FE: <strong>{selected.fe_detail?.name_of_fe || formData._fe_display || ''}</strong>
                  &nbsp;|&nbsp; Date: <strong>{selected.date}</strong>
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <StatusChip status={selected.status} />
                <Button variant="outlined" size="small" startIcon={<Print />} onClick={() => window.print()}>
                  Print
                </Button>
              </Box>
            </Box>
            <Divider sx={{ mb: 2 }} />

            <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden', mb: 2 }}>
              <Box sx={{ background: '#1976d2', color: '#fff', px: 2, py: 1 }}>
                <Typography variant="body2" fontWeight="bold">Sl.No</Typography>
              </Box>
              {items.map((item, idx) => (
                <Box key={idx} sx={{ display: 'flex', gap: 1, p: 1,
                  borderBottom: idx < items.length - 1 ? '1px solid #eee' : 'none' }}>
                  <Box sx={{ pt: 1.5, minWidth: 28 }}>
                    <Typography variant="body2" color="text.secondary">{idx + 1}</Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <MatrixRow item={item} idx={idx} ro={true}
                      onUpdate={() => {}} onDelete={() => {}} onFileChange={() => {}} />
                  </Box>
                </Box>
              ))}
            </Box>

            <ApprovalPanel form={selected} apiPath={EP} role={role}
              onRefresh={() => openView(selected)} />

            <Box sx={{ mt: 2 }}>
              <Button variant="outlined" onClick={() => setView('list')}>Back to List</Button>
            </Box>
          </>
        )}
      </Box>

      <SnackBarComponent open={snack.open} message={snack.message}
        severity={snack.severity} onClose={() => setSnack(s => ({ ...s, open: false }))} />
    </Box>
  );
};